import React, { Component } from "react";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import swal from "sweetalert";
import PhotoForm from "./photoform";
import Header from "../../Header/header";
import { accessControl } from "../../../permission/permission";

class AddGallery extends Component {
  constructor() {
    super();
    accessControl([1, 4]);
    this.state = {
      isLoading: "off",
      imagefile: "",
      htmlelement: <i className="fa fa-user fa-8x" aria-hidden="true" />,
      formData: {
        category: "",
        SubCategoryID: "",
        ImageTitle: "",
        FacultyCode: "",
        image: "",
        photo: "",
      },
      categoryList: [],
      subCategoryList: [],
    };
  }

  componentDidMount() {
    this.fetchGalleryCategoryList();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      isLoading: "on",
    });
    this.onAddPhoto();
  };

  async fetchGalleryCategoryList() {
    await fetch(`${serverLink}gallery/category/list`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        this.setState({
          categoryList: data,
          isLoading: false,
        });
      });
  }

  async fetchGallerySubCategoryList(categoryID) {
    await fetch(`${serverLink}gallery/subcategory/list/${categoryID}`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        this.setState({
          subCategoryList: data,
          isLoading: false,
        });
      });
  }

  async onAddPhoto() {
    let sendData = {
      ...this.state.formData,
      InsertedBy: "Sani Muhammad Garga",
    };

    if (this.state.formData.category === "") {
      this.setState({
        isLoading: false,
      });
      this.showAlert("FORM VALIDATION ERROR", "Please select category", "error");
      return false;
    }

    if (this.state.formData.SubCategoryID === "") {
      this.setState({
        isLoading: false,
      });
      this.showAlert("FORM VALIDATION ERROR", "Please select sub category", "error");
      return false;
    }

    if (this.state.formData.imagefile === "") {
      this.setState({
        isLoading: false,
      });
      this.showAlert("FORM VALIDATION ERROR", "Please select image", "error");
      return false;
    }

    if (this.state.formData.ImageTitle === "") {
      this.setState({
        isLoading: false,
      });
      this.showAlert("FORM VALIDATION ERROR", "Please enter image title", "error");
      return false;
    }

    axios
      .post(`${serverLink}gallery/add`, sendData)
      .then((result) => {
        this.setState({
          isLoading: false,
        });
        const response = result.data.message;
        if (response === "name exist") {
          this.showAlert("Oops!", "gallery with the same name and title already exist", "error");
          return false;
        } else if (response === "failed") {
          this.showAlert("Oops!", "Something went wrong adding the gallery. Please try again!", "error");
          return false;
        } else if (response === "success") {
          if (this.state.imagefile !== "") {
            const formData = new FormData();
            formData.append("photo", this.state.imagefile);
            formData.append("entry_id", result.data.entry_id);
            axios
              .patch(`${serverLink}gallery/uploadGalleryPhoto`, formData)
              .then((result) => {
                this.setState({
                  isLoading: false,
                });
                const res = result.data.lastID;
                console.log(res);
              })
              .catch((err) => {
                this.setState({
                  isLoading: false,
                });
                console.error("ERROR", err);
              });
          }
          this.showSuccessAlert("SUCCESS", "GALLERY ADDED SUCCESSFULLY", "success");
          return false;
        } else {
          this.showAlert("Oops!", "Failed to add the gallery details!", "error");
          return false;
        }
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
        console.error("ERROR", err);
      });
  }

  onEdit = (e) => {
    const formData = this.state.formData;
    console.log(e.target.name);
    if (e.target.name === "category") {
      this.fetchGallerySubCategoryList(e.target.value);
      this.setState({
        formData: {
          ...formData,
          [e.target.name]: e.target.value,
        },
      });
    }
    this.setState({
      formData: {
        ...formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      this.setState({
        imagefile: event.target.files[0],
      });

      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          htmlelement: (
            <div className="addpersonpage">
              <img className="netimage" srcSet={e.target.result} alt="profileImage" />
            </div>
          ),
        });
      };
      reader.readAsDataURL(event.target.files[0]);
      this.setState({});
    }
  };

  showSuccessAlert(title, msg, type) {
    return swal({
      title: title,
      text: msg,
      icon: type,
      button: "OK",
    }).then((value) => {
      window.location.href = "/about/gallery/list";
    });
  }

  showAlert(title, msg, type) {
    return swal({
      title: title,
      text: msg,
      icon: type,
      button: "OK",
    });
  }
  render() {
    return (
      <>
        <Header isFaculty={false} />
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="toolbar" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
              <div
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
              >
                <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                  ABOUT
                  <span className="h-20px border-dark  border-start ms-3 mx-2" />
                  GALLERY
                  <span className="h-20px border-dark  border-start ms-3 mx-2" />
                  MANAGE GALLERY
                </h1>
              </div>
            </div>
          </div>
          <div className="post d-flex flex-column-fluid" id="kt_post">
            <div id="kt_content_container" className="container-fluid">
              {/* CONTENT START */}
              <div className="card mb-5 mb-xl-10">
                <div className="card-header">
                  <div className="card-title">
                    <h3>MANAGE GALLERY</h3>
                  </div>
                </div>
                <PhotoForm
                  handleSubmit={this.handleSubmit}
                  onEdit={this.onEdit}
                  onImageChange={this.onImageChange}
                  isLoading={this.state.isLoading}
                  data={this.state.formData}
                  categoryList={this.state.categoryList}
                  subCategoryList={this.state.subCategoryList}
                />
              </div>
              {/* CONTENT END */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AddGallery;
